import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import { Box, CircularProgress, Backdrop } from '@mui/material';
import { useAuthState } from '../../stores/authStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import { useEventState } from '../../stores/eventStore';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
    REQUEST_STATUS_LIST
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CommonRequests from '../../sharedcomponents/commonRequest/commonRequest';
//import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { HOTEL_ROOM_TAX } from '../../constants/Constant';
import { useAgentState } from '../../hookState/AgentState';
import { updateModuleState } from '../../stores/eventStore';
import { MODULE_LIST } from '../../constants/Constant';
import AppConstants from '../../constants/appConstants'
import { makeStyles } from '@mui/styles';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 150,
        color: '#fff',
    },
}));

const Hotel = (props) => {
    const classes = useStyles();
    const showSearch = true;
    const agentState = useAgentState();
    const agentInfo = Helper.getSessionStorage('agentUser');
    const userInfo = Helper.getStorage('userInfo');
    const eventModuleConfigInfo = Helper.getStorage('eventModuleConfig') ?? [];
    const hotelEventConfig =
        (eventModuleConfigInfo && eventModuleConfigInfo.moduleDetails) &&
        eventModuleConfigInfo.moduleDetails.filter(
            (key) =>
                key?.moduleName?.toLowerCase() ===
                MODULE_LIST[3].toLocaleLowerCase()
        );
    var hotelKeyValue =
        hotelEventConfig &&
        hotelEventConfig.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.description }),
            {}
        );

    // const openDialog = useState(false);
    //const transittype = useState(null);
    const eventState = useEventState();
    const history = useHistory();
    const authState = useAuthState();
    const loading = useState(false);
    const allData = useState();
    const allListData = useState([]);
    const eventData = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    // const moduleIndex = useState(0)
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [isParticipant, setIsParticipant] = React.useState(false);
    const [showToggle, setShowToggle] = React.useState(true);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [hotelRoomTax, setHotelRoomTax] = React.useState([]);
    const [eventConfig, setEventConfig] = React.useState({
        paid: 0,
        comp: 0,
    });
    const [isAgentRequestAccepted, setIsAgentRequestAccepted] = React.useState(undefined);
    const [showAgentRequestConfirmDialog, setShowAgentRequestConfirmDialog] = React.useState(false);
    const [openBackDrop, setOpenBackDrop] = React.useState(false);

    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            !Helper.isAdminUser(userInfo) ||
            !Helper.isEventAdmin(userInfo) ||
            !Helper.isEventAgent(userInfo) ||
            !Helper.isEventStaff(userInfo)
        ) {
            setIsParticipant(true);
        } else {
            setIsParticipant(false);
        }
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            const userInfo = Helper.getStorage('userInfo');
            if (!Helper.isAdminUser(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'HOTEL')
                    );
                }
            } else if (Helper.isAdminUser(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminHotelRequestList();
            }
        }
    }, [modPermission]);

    useEffect(() => {
        fetchHotelRoomTax();
        fetchEventDefaultConfig();
        fetchAgentRoomRequest();
    }, []);
    
    //Commented for popup as we moved this to registrations
    // useEffect(() => {
    //     if ((isAgentRequestAccepted === null || isAgentRequestAccepted === '') && eventConfig && eventConfig.paid > 0) {
    //         setShowAgentRequestConfirmDialog(true);
    //     }
    // }, [isAgentRequestAccepted, eventConfig])

    // const getModuleDetailsData = () => {
    //     const index = eventState.eventDetail.get().moduleDetails.findIndex((element) => {
    //         if (element.moduleName === 'Hotel') {
    //           return true
    //         }
    //       })
    //       moduleIndex.set(index)

    //     // if (eventStateDetail.get()) {
    //     //     const permissions = eventStateDetail.permissions.attach(Downgraded).get();
    //     //     if (permissions && permissions.length > 0) {
    //     //         setCheckEditPermission(Helper.getModulePermission(permissions, 'REGISTRATION'));
    //     //     }
    //     // }
    // }

    const handleChangeRoomTax = (event) => {
        // console.log('this', event);
        //console.log('this1', event.target);
    };

    const fetchAgentRoomRequest = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        ApiHelper.get(
            APIURLConstants.GET_AGENT_ROOM_REQUEST_BY_USERID(
                gEventInfo.eventID,
                4,
                agentConnection && gAgentInfo
                    ? gAgentInfo.userID
                    : userInfo.userID
            )
        ).then((res) => {
            setIsAgentRequestAccepted(res.data);

        }).catch((err) => {
            console.log('error while getting agent Room request', err)
        });
    }

    const fetchEventDefaultConfig = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        ApiHelper.get(
            APIURLConstants.GET_DRAFTCOMBINE_SETTING_BY_USERID(
                gEventInfo.eventID,
                agentConnection && gAgentInfo
                    ? gAgentInfo.userID
                    : userInfo.userID
            )
        ).then((res) => {
            if (res.data) {
                const parseData = JSON.parse(res.data.setting);
                if (parseData !== undefined && parseData.length > 0) {
                    const settingParseData = JSON.parse(
                        parseData[0].HotelSetting
                    );
                    setEventConfig({
                        paid: settingParseData && settingParseData.pay ? Number(settingParseData.pay) : 0,
                        comp: settingParseData && settingParseData.comp ? Number(settingParseData.comp) : 0,
                    });
                    // setHotelPurchaseAllotmentCount(Number(settingParseData.pay) - res.data.actualPayCount)
                    // setHotelCompAllotmentCount(Number(settingParseData.comp) - res.data.actualCompCount);
                }
            }
        });
        // ApiHelper.get(
        //     APIURLConstants.GET_EVENT_DEFAULTS(
        //         eventInfo.eventID,
        //         0,
        //         userInfo.userID
        //     )
        // ).then((res) => {
        //     console.log(res);
        //     // setEventConfig({
        //     //     ...eventConfig,
        //     //     paid: res.data.hotelPaid,
        //     //     comp: res.data.hotelComp,
        //     // });
        // });
    };
    const fetchHotelRoomTax = () => {
        ApiHelper.get(APIURLConstants.GET_HOTEL_ROOM_TAX).then((res) => {
            if (res.data) {
                setHotelRoomTax(res.data);
            }
        });
    };
    const getAdminHotelRequestList = () => {
        let participantList = [];
        const userInfo = Helper.getStorage('userInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_COMBINE_HOTELBOOKING_LIST(
                eventData.get().eventID,
                agentConnection && gAgentInfo
                    ? gAgentInfo.userID
                    : userInfo.userID,
                agentConnection && gAgentInfo
                    ? false : userInfo.userType == 'Admin' ? true : false,
                false,
                pagingInfo.get().currentPage,
                pagingInfo.get().itemsPerPage
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    if (data.length > 0) {
                        data.map((item) => {
                            if (
                                item.hotelAllStarSettings != undefined &&
                                item.hotelAllStarSettings.length > 0
                            ) {
                                const jsonD = JSON.parse(
                                    item.hotelAllStarSettings[0].setting
                                );
                                if (jsonD.length > 0) {
                                    const parseHotelSetting = JSON.parse(
                                        jsonD[0].HotelSetting
                                    );
                                    setEventConfig({
                                        paid: parseHotelSetting && parseHotelSetting.pay ? Number(parseHotelSetting.pay) : 0,
                                        comp: parseHotelSetting && parseHotelSetting.comp ? Number(parseHotelSetting.comp) : 0,
                                    });
                                    // console.log("item.hotelAllStarSettings[0].setting", JSON.parse(jsonD[0].HotelSetting));
                                }
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            requestData.push({
                                actualData: item,
                                row: [
                                    // {
                                    //     label: 'checkbox',
                                    //     key: 'hotelBookID',
                                    //     hotelBookID: item.hotelBookID,
                                    //     width: '0.05',
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },
                                    // {
                                    //     label: 'Hotel Name',
                                    //     key: 'hotelName',
                                    //     hotelName: item.hotelName,
                                    //     width: '0.30',
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },
                                    {
                                        label: 'First Name',
                                        key: 'firstName',
                                        firstName: item.firstName,
                                        width: '0.15',
                                        // showLabel: true,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Last Name',
                                        key: 'lastName',
                                        lastName: item.lastName,
                                        width: '0.15',
                                        // showLabel: true,
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Submitted By',
                                        key: 'createdBy',
                                        createdBy: item.createdByName,
                                        width: '0.20',
                                        inColumn: true,
                                        // alignCenter: true,
                                    },

                                    {
                                        label: 'Room Type',
                                        key: 'hotelRoom',
                                        hotelRoom: item.hotelRoomTax,
                                        // hotelRoomValue: item.hotelRoomTaxID,
                                        width: '0.20',
                                        inColumn: true,
                                        // showHotelToggle: true,
                                        // asList: true,
                                        // alignCenter: true,
                                    },

                                    {
                                        label: 'Check In',
                                        key: 'checkIn',
                                        checkIn: Helper.FormatDate(
                                            item.checkIn
                                        ),
                                        width: '0.15',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Check Out',
                                        key: 'checkOut',
                                        checkOut: Helper.FormatDate(
                                            item.checkOut
                                        ),
                                        width: '0.15',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Bed Type',
                                        key: 'bedType',
                                        bedType: item.hotelRoomType,
                                        // hotelRoomValue: item.hotelRoomTaxID,
                                        width: '0.10',
                                        inColumn: true,
                                        // showHotelToggle: true,
                                        // asList: true,
                                        // alignCenter: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.10',
                                        showStatusIcon: true,
                                        //inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'editnote',
                                        editnote: item.requestStatus != "Pending" ? item.note : "",
                                        width: '0.1',
                                    },

                                    // {
                                    //     label: 'Action',
                                    //     key: 'edit',
                                    //     edit: 'Edit',
                                    //     width: '0.15',
                                    // },
                                ],
                                selected: false,
                            });
                        });
                    } else {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                    }
                    setShowSearchRec(false);
                    allData.set(requestData);
                    allListData.set(requestData);
                    setFilters({
                        hotelName: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    const handleConfirmation = () => {
        let deleteRequests = [];
        allData.get().map((row) => {
            if (row.selected === true) {
                deleteRequests.push(row.actualData.hotelBookID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_HOTELBOOKING, {
            Ids: deleteRequests.join(','),
            SoftDelete: true,
            ModifiedBy: userID.value,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    //props.onDelete(false);
                    setAll.set(false);
                    getAdminHotelRequestList();
                    //getEmailNotification();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const handlePageChange = (event, page) => {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getAdminHotelRequestList();
    };

    const onActionClick = (index, action) => {
        let newData = [...allData.attach(Downgraded).get()];
        let newItem = newData[index];

        const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
        requestNote.set({
            hotelBookID: newItem.actualData.hotelBookID,
            status: isStatus,
            userID: userID.get(),
            action,
            note: newItem.note,
        });
        openNoteDialog.set(true);
    };

    //// After Completed New Request Page Then Un Commet
    const redirectToEditHotelRequest = (data) => {
        const compCount = CountNumberOfOccuranceOfString(
            allData.attach(Downgraded).get(),
            HOTEL_ROOM_TAX[0]
        );
        const paidCount = CountNumberOfOccuranceOfString(
            allData.attach(Downgraded).get(),
            HOTEL_ROOM_TAX[1]
        );

        const row = data.actualData;
        const path = generatePath(RouteConstants.EDIT_HOTEL_EVENT, {
            eventID: eventData.get().eventID,
            hotelBookingID: row.hotelBookID,
        });

        history.push({
            pathname: path,
            state: {
                hotelState: row,
                roomState: { compCount: compCount, paidCount: paidCount },
                admin: false,
            },
        });
    };

    const CountNumberOfOccuranceOfString = (array, find, requestStatus = '') => {
        let count = 0;
        if (array && array.length > 0) {
            if (!requestStatus) {
                count = array.filter((obj) => obj.actualData.hotelRoomTax === find && obj.actualData.requestStatus !== 'To Do')
                    .length;
            }
            else if (requestStatus === 'Pending') {
                count = array.filter((obj) => obj.actualData.hotelRoomTax === find && obj.actualData.requestStatus === requestStatus)
                    .length;
            }
            else if (requestStatus === 'Approved') {
                count = array.filter((obj) => obj.actualData.hotelRoomTax === find && obj.actualData.requestStatus === requestStatus)
                    .length;
            }
        }
        return count;
    };

    const onAddRequest = () => {
        const compCount = CountNumberOfOccuranceOfString(
            allData.attach(Downgraded).get(),
            HOTEL_ROOM_TAX[0]
        );
        const paidCount = CountNumberOfOccuranceOfString(
            allData.attach(Downgraded).get(),
            HOTEL_ROOM_TAX[1]
        );

        if (
            eventConfig.comp - compCount === 0 &&
            eventConfig.paid - paidCount === 0
        ) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'All rooms are occupied, you cannot add request.',
            });
            // return
        }

        props.history.push({
            pathname: generatePath(RouteConstants.CREATE_EVENT_HOTEL, {
                eventID: eventData.get().eventID,
            }),
            state: {
                roomState: { compCount: compCount, paidCount: paidCount },
                admin: false,
                isAgentRequestAccepted: isAgentRequestAccepted
            },
        });
    };

    const onDelete = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const handleAgentRoomConfirmation = (accepted) => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        let obj = {};
        obj.eventID = gEventInfo.eventID;
        obj.moduleID = 4;
        obj.userID = agentConnection && gAgentInfo
            ? gAgentInfo.userID
            : userInfo.userID;
        obj.IsAgentRoomRequestAccepted = accepted;
        obj.createdBy = userInfo.userID;
        setOpenBackDrop(true);
        ApiHelper.post(APIURLConstants.INS_UPD_HOTEL_AGENT_REQUEST, obj)
            .then((res) => {
                setOpenBackDrop(false);
                if (res.data) {
                    setIsAgentRequestAccepted(accepted);
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    setShowAgentRequestConfirmDialog(false);
                    getAdminHotelRequestList();
                }
            })
            .catch((error) => {
                setOpenBackDrop(false);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while updating request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                setShowAgentRequestConfirmDialog(false);
            });


    }

    const editAllToggle = () => {
        setShowToggle(!showToggle);
    };
    //// After Completed New Request Page Then Un Commet
    // const handleAction = (value) => {

    //     transittype.set(value);
    //     history.push({
    //         pathname: RouteConstants.EVENT_CREATE_TRANSIT,
    //         state: { transitType: value },
    //     });
    //     openDialog.set(false);
    // };

    return (
        <Box sx={{ width: '100%' }}>
            {/* {
                (eventState.eventDetail.get().moduleDetails[moduleIndex.get()].details != null || "") &&
                <Box
                    sx={{
                        width: '100%',
                        boxShadow:
                            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
                        borderRadius: 4,
                        pt: 1,
                        pr: 3,
                        pb: 1,
                        pl: 3,
                        mb: 1,
                        backgroundColor: '#fff',
                    }}>
                    <DetailsComponent data={eventState.eventDetail.get().moduleDetails[moduleIndex.get()].details} />
                </Box>
            } */}

            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <CommonRequests
                    // new props
                    data={allData.attach(Downgraded).get()}
                    editRow={redirectToEditHotelRequest}
                    showEdit={false}
                    showEditHotel={false}
                    //editAll={editAll}
                    handleClick={onAddRequest}
                    title={''}
                    // disableAdd={
                    //     allData.attach(Downgraded).length != 0 ? true : false
                    // }
                    // editButtonTitle={'Edit All'}
                    buttonTitle={'Add'}
                    // deleteRows={onDelete}
                    showSearch={showSearch}
                    searchLabel={'Search'}
                    showFilter={isParticipant ? false : true}
                    filters={filters}
                    showSearchRec={showSearchRec}
                    setShowSearchRec={setShowSearchRec}
                    onActionClick={onActionClick}
                    getResults={getAdminHotelRequestList}
                    pagingInfo={pagingInfo.attach(Downgraded).get()}
                    handlePageChange={handlePageChange}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    moduleToShow={'Hotel'}
                    moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                        AppConstants.EVENT_MODULES.COMBINE_HOTEL)}
                    modPermission={modPermission}
                    hideDelete={true}
                    showHotelToggle={showToggle}
                    asListRoomTax={hotelRoomTax}
                    handleChangeRoomTax={handleChangeRoomTax}
                    saveHotelButtonTitle={'Save'}
                    editAllToggle={editAllToggle}
                    eventConfigStatus={eventConfig}
                    compUsed={
                        allData.attach(Downgraded).length > 0
                            ? CountNumberOfOccuranceOfString(
                                allData.attach(Downgraded).get(),
                                HOTEL_ROOM_TAX[0]
                            )
                            : 0
                    }
                    purchaseUsed={
                        allData.attach(Downgraded).length > 0
                            ? CountNumberOfOccuranceOfString(
                                allData.attach(Downgraded).get(),
                                HOTEL_ROOM_TAX[1]
                            )
                            : 0
                    }
                    pendingWaitList={
                        allData.attach(Downgraded).length > 0
                            ? CountNumberOfOccuranceOfString(
                                allData.attach(Downgraded).get(),
                                HOTEL_ROOM_TAX[2], 'Pending'
                            )
                            : 0
                    }
                    approvedWaitList={
                        allData.attach(Downgraded).length > 0
                            ? CountNumberOfOccuranceOfString(
                                allData.attach(Downgraded).get(),
                                HOTEL_ROOM_TAX[2], 'Approved'
                            )
                            : 0
                    }
                    hotelKeyValue={hotelKeyValue}
                    endUserView
                    showAgentRoomInfo={false}
                    isAgentRequestAccepted={isAgentRequestAccepted}
                    handleAgentRoomConfirmation={handleAgentRoomConfirmation}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}

            {
                <ConfirmationDialog
                    open={showAgentRequestConfirmDialog}
                    message={AppConstants.HOTEL_AGENT_ROOM_CONFIRM_TEXT}
                    OkButtonText={'No'}
                    handleCnfClick={() =>
                        handleAgentRoomConfirmation(false)
                    }
                    CancelButtonText={'Yes'}
                    onCancelClick={() => {
                        handleAgentRoomConfirmation(true)
                    }}></ConfirmationDialog>
            }

            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <Backdrop className={classes.backdrop} open={openBackDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            }
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.EVENT_HOTEL,
        component: Hotel,
    },
    name: 'Hotel',
};
